import { atom } from 'jotai';

export const needRefetchFilteredDataAtom = atom(false);
export const needRefetchKeywordSearchedDataAtom = atom(false);
